let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k6Fy0")).then(() => parcelRequire('83EtJ'));